export const getUserEventTypes = (state) => state.events.userEventTypes;
export const getSeriesEvents = (state) => state.events.seriesEvents;
export const getIotUpdated = (state) => state.events.iotUpdatedAt;
export const getIsExporting = (state) => state.events.isExporting;
export const getEventNotifications = (state) => state.events.eventNotifications;
export const getImportErrors = (state) => state.events.importErrors;
export const getImportedAt = (state) => state.events.importedAt;
export const getEventOrder = (state) => state.events.order;
